import { IFormFields } from './types';

export const DEFAULT_FORM_VALUES: IFormFields = {
  promoCode: null,
  discount: null,
  clientUUID: null,
  method: null,
  card_sum: '',
  cash_sum: '',
};
